import script from "./MessageCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageCenter.vue?vue&type=script&setup=true&lang=js"

import "./MessageCenter.vue?vue&type=style&index=0&id=da8a49fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da8a49fc"]])

export default __exports__